import React, { useEffect, useState } from 'react';

const BackgroundStep = ({ selectedBackground, setSelectedBackground, onNext, onBack }) => {
  const backgrounds = [
    {
      id: 'cny-reunion',
      name: 'CNY Reunion',
      description: 'Traditional Chinese New Year family gathering',
      icon: '🧧',
      preview: 'Red lanterns, festive decorations, family dining table'
    },
    {
      id: 'pickleball-court',
      name: 'Pickleball Court',
      description: 'Active sports court setting',
      icon: '🏓',
      preview: 'Modern pickleball court with net and colorful surface'
    },
    {
      id: 'office',
      name: 'Office',
      description: 'Professional workplace environment',
      icon: '💼',
      preview: 'Modern office space with desks and computers'
    },
    {
      id: 'dating-cafe',
      name: 'Dating Café',
      description: 'Cozy romantic café atmosphere',
      icon: '☕',
      preview: 'Warm lighting, intimate seating, coffee shop ambiance'
    },
    {
      id: 'disco',
      name: 'Disco',
      description: 'Vibrant nightclub dance floor',
      icon: '🕺',
      preview: 'Colorful lights, dance floor, party atmosphere'
    },
    {
      id: 'beach',
      name: 'Beach',
      description: 'Tropical seaside paradise',
      icon: '🏖️',
      preview: 'Sandy beach, palm trees, ocean waves'
    },
    {
      id: 'ev-launch',
      name: 'EV Launch',
      description: 'Futuristic electric vehicle showcase',
      icon: '⚡',
      preview: 'Modern EV showroom with sleek vehicles'
    },
    {
      id: 'original',
      name: 'Original',
      description: 'Use your uploaded image as background',
      icon: '📷',
      preview: 'Your original uploaded background image'
    }
  ];

  const [shouldAutoAdvance, setShouldAutoAdvance] = useState(false);

  const handleBackgroundSelect = (background) => {
    setSelectedBackground(background);
    setShouldAutoAdvance(true);
  };

  // Auto advance only when background is newly selected
  useEffect(() => {
    if (selectedBackground && shouldAutoAdvance) {
      // Add a small delay to let the user see their selection
      const timer = setTimeout(() => {
        onNext();
        setShouldAutoAdvance(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [selectedBackground, onNext, shouldAutoAdvance]);

  return (
    <div className="step-container">
      <div className="step-header-with-nav">
        <div className="navigation-buttons">
          <button className="btn-back" onClick={onBack}>
            ← Back
          </button>
        </div>
        <h3 style={{ margin: '0' }}>Choose Background Scene</h3>
        <div className="navigation-buttons">
          <button 
            className="btn-next"
            onClick={onNext}
            disabled={!selectedBackground}
          >
            Next: Upload →
          </button>
        </div>
      </div>
      <div className="step-header">
        <p>Select the perfect setting for your AI fashion video</p>
      </div>

      <div className="backgrounds-grid">
        {backgrounds.map((background) => (
          <div
            key={background.id}
            className={`background-card ${
              selectedBackground?.id === background.id ? 'selected' : ''
            }`}
            onClick={() => handleBackgroundSelect(background)}
          >
            <div className="background-icon">{background.icon}</div>
            <h4>{background.name}</h4>
            <p className="background-description">{background.description}</p>
            <div className="background-preview">{background.preview}</div>
            {selectedBackground?.id === background.id && (
              <div className="selected-indicator">✓</div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
};

export default BackgroundStep;